export const enum feeConstants {
  // Get Fee List
  getFeeRequest = "GET_FEE_REQUEST",
  getFeeSuccess = "GET_FEE_SUCCESS",
  getFeeFailure = "GET_FEE_FAILURE",

  // Get Fee List with Params
  getFeeParamsRequest = "GET_FEE_PARAMS_REQUEST",
  getFeeParamsSuccess = "GET_FEE_PARAMS_SUCCESS",
  getFeeParamsFailure = "GET_FEE_PARAMS_FAILURE",

  // Create/Update Fee
  createFeeRequest = "CREATE_FEE_REQUEST",
  createFeeSuccess = "CREATE_FEE_SUCCESS",
  createFeeFailure = "CREATE_FEE_FAILURE",
  createFeeReset = "CREATE_FEE_RESET",

  // Delete Fee
  deleteFeeRequest = "DELETE_FEE_REQUEST",
  deleteFeeSuccess = "DELETE_FEE_SUCCESS",
  deleteFeeFailure = "DELETE_FEE_FAILURE",
  deleteFeeReset = "DELETE_FEE_RESET",

  // Get Fee View
  feeViewRequest = "FEE_VIEW_REQUEST",
  feeViewSuccess = "FEE_VIEW_SUCCESS",
  feeViewFailure = "FEE_VIEW_FAILURE",

  // Get Student Fee Summary
  getStudentFeeSummaryRequest = "GET_STUDENT_FEE_SUMMARY_REQUEST",
  getStudentFeeSummarySuccess = "GET_STUDENT_FEE_SUMMARY_SUCCESS",
  getStudentFeeSummaryFailure = "GET_STUDENT_FEE_SUMMARY_FAILURE",

  // Get Enrollment Fee History
  getEnrollmentFeeHistoryRequest = "GET_ENROLLMENT_FEE_HISTORY_REQUEST",
  getEnrollmentFeeHistorySuccess = "GET_ENROLLMENT_FEE_HISTORY_SUCCESS",
  getEnrollmentFeeHistoryFailure = "GET_ENROLLMENT_FEE_HISTORY_FAILURE",
  getEnrollmentFeeHistoryReset = "GET_ENROLLMENT_FEE_HISTORY_RESET",
}
